import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const adminKopilotInvoiceRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/kopilot/invoices/$id',
  params: z.object({ id: zodPathParamId }),
  validateSearch: z.object({
    tab: z.enum(['matching', 'parsing', 'line_items']).default('matching'),
  }),
}).lazy(() =>
  import('pages/admin/KopilotInvoices/AdminKopilotInvoicePage/AdminKopilotInvoicePage').then(
    (d) => d.Route
  )
);
